import React from 'react';
import Styled from 'styled';
import { FormattedMessage } from 'react-intl';

import news from 'four-nets/icons/svg/icon_newsletter.svg';
import projectIcon from 'four-nets/icons/svg/icon_project.svg';

import defaultStyles from './author-project.scss';
import AuthorSVGIcon from '../author-svg-icon/author-svg-icon';
import { AuthorProjectFragment } from './author-project.graphql';

export interface Props extends AuthorProjectFragment {
    styles: typeof defaultStyles;
}

function AuthorProject(props: Props) {
    const { styles, project, profile } = props;

    if (project === null || (profile && profile.isVendor)) {
        return null;
    }

    return (
        <div className={styles.livingInfo}>
            <div className={styles.sectionTitle}>
                <FormattedMessage id='LIVING_INFO' />
            </div>
            <div className={styles.row}>
                <AuthorSVGIcon src={news} />
                <FormattedMessage id='LISTING_STATE' />
                &nbsp;&nbsp;&nbsp;
                {project.project}
            </div>
            <div className={styles.row}>
                <AuthorSVGIcon src={projectIcon} />
                <FormattedMessage id='PROJECT' />
                &nbsp;&nbsp;&nbsp;
                {project.property}
            </div>
        </div>
    );
}

export default Styled(defaultStyles)(AuthorProject);
